import { CheckCircleOutline, CancelOutlined, DeleteOutline } from '@mui/icons-material';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Box, Typography } from '@mui/material';

function BulkVoteActionDialog({ open, onClose, onAction, selectedCount }) {
  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth="xs">
      <DialogTitle>Toplu Oylama İşlemi</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Seçili <strong>{selectedCount}</strong> karar için ne yapmak istiyorsunuz?
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Button
            variant="contained"
            color="success"
            startIcon={<CheckCircleOutline />}
            onClick={() => onAction(1)}
            fullWidth
          >
            Kabul
          </Button>
          <Button
            variant="contained"
            color="error"
            startIcon={<CancelOutlined />}
            onClick={() => onAction(2)}
            fullWidth
          >
            Ret
          </Button>
          <Button
            variant="contained"
            color="warning"
            startIcon={<DeleteOutline />}
            onClick={() => onAction(0)}
            fullWidth
          >
            Sil
          </Button>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Vazgeç</Button>
      </DialogActions>
    </Dialog>
  );
}

export default BulkVoteActionDialog;
